export default {
    '-': "-",
    actions: "Аракеттер",
    actions_with_selected: "Тандалган менен аракеттер",
    active: "Активдүү",
    add: "Кошуу",
    add_attachment: "Тиркемени кошуу",
    add_condition: "Шартты кошуу",
    afternoon: "Түш",
    all: "Баары",
    app_is_in_maintenance_mode: "Тиркемеде техникалык иштер жүрүп жатат. Жакын арада сөзсүз кайтып келебиз",
    are_you_sure_you_want_to_delete: "Сиз чындыгында материалды алып салгыңыз келеби?",
    are_you_sure_you_want_to_logout: "Сиз чындыгында чыккыңыз келеби?",
    assistant_id: "Жардамчы",
    authorization: "Авторизациялоо",
    authorize_in_system: "Системада авторизациялоо",
    azerbaijani: "Азербайджан",
    balance: "Депозит",
    cancel: "Жокко чыгаруу",
    cancel_verb: "Жокко чыгаруу",
    change: "Өзгөртүү",
    change_password: "Жашырынсөздү өзгөртүү",
    comment: "Комментарий",
    confirm_deletion: "Орнотууну ырастайсызбы?",
    contacts: "Байланыштар",
    contains: "Камтыйт",
    continue: "Улантуу",
    credit: "Кредит",
    currency: "Валюта",
    custom_role_rights_updated: "Роль укуктары жаңыртылды",
    delete: "Өчүрүү",
    dentistry: "Стоматология",
    do_not_save: "Сактаба",
    does_not_equal: "Барабар эмес",
    done: "Даяр",
    down: "Ылдый",
    edit: "Өзгөртүү",
    egisz_send_error: "ССЧБММСга жөнөтүү катасы",
    egisz_send_success: "ССЧБММСга ийгиликтүү жөнөтүлдү",
    email: "Email",
    email_required_for_password_reset: "Бул колдонуучунун сырсөзүн калыбына келтирүү үчүн анын email дареги көрсөтүлүшү керек",
    end: "Аяктоо",
    english: "Англис",
    enter_username_to_reset_password: "Жашырынсөздү калыбына келтирүү шилтемесин алуу үчүн логиниңизди киргизиңиз",
    equals: "Бир жерден ката кетти, операция ийгиликтүү аяктаган жок",
    error: "Ката",
    error_message: "Бир жерден ката кетти, операция ийгиликтүү аяктаган жок",
    evening: "Кеч",
    excel: "Excel",
    exported_patients_to_excel: "Бейтаптарды Excel программасына жүктөгөн",
    exported_report_to_excel: "Отчётту Excel программасына жүктөгөн",
    fact: "Факт",
    family_account_member_toggled: "Үй-бүлөлүк эсеп мүчөсүнүн активдүүлүгүн өзгөрттү",
    family_account_updated: "Үй-бүлөлүк эсептин курамын жаңыртты",
    file: "Файл",
    file_does_not_exist: "Файл табылган жок",
    file_size_is_too_big: "Файлдын көлөмү өтө чоң",
    filled: "Толтурулган",
    filled_not_signed: "Толтурулган / кол коюлбаган",
    filter: "Фильтр",
    finish: "Аяктоо",
    finishing_operation: "Операцияны аяктоо",
    forgot_password: "Жашырынсөзүңүдү унутуп калдыңызбы?",
    from_to: "{from} чейин {to}",
    general_cost: "Жалпы чыгым",
    general_medicine: "Жалпы медицина",
    general_slogan: "Заманбап клиниканы башкаруу үчүн булут чечими",
    hide: "Катуу",
    hide2: "Жашыруу",
    home: "Башкы",
    image: "Сүрөт",
    import: "Импорт",
    in_interval: "Интервалда",
    input_field: "Текст киргизүү талаасы",
    integration: "Интеграция",
    invalid_reset_link: "Бул жашырынсөздү калыбына келтирүү шилтемеси жараксыз же мөөнөтү өтүп кеткен",
    kazakh: "Казак",
    kyrgyz: "Кыргыз",
    KZT: "KZT",
    language: "Тил",
    less: "Кем",
    links: "Шилтемелер",
    load_more: "Загрузить еще",
    logged: "ыйгарым укуктуу",
    logged_out: "Системадан чыкты",
    login: "Логин",
    login_disclaimer: "DENTIST PLUS системасына кирүүнү улантуу менен, сиз өз эсептик жазууңузду колдонуп жатканыңызды тастыктайсыз жана эсептик маалыматтарыңызды колдонуу менен жасалган аракеттер үчүн жоопкерчиликти өз мойнуңузга аласыз. Эсептик маалыматтарды үчүнчү жактарга берүү тыюу салынат.",
    login_failed: "Системага кирүү аракети ийгиликсиз болду",
    login_locked_out: "Кирүү бөгөттөлдү (көп аракет)",
    login_or_pass_incorrect: "Логин жана / же жашырынсөз туура эмес",
    logout: "Чыгуу",
    main: "Башкы",
    message: "Билдирме",
    module_unavailable: "Модуль жеткиликсиз",
    months: "Ай",
    more: "Ашык",
    more_2: "Дагы",
    morning: "Эртең менен",
    must_change_password_notice: "Улантуу үчүн жашырынсөздү өзгөртүү зарыл",
    name: "Аты",
    new_password: "Жаңы жашырынсөз",
    no: "Жок",
    no_data_available: "Азырынча маалымат жок",
    nonactive: "Активдүү эмес",
    not_enough_rights_for_this_operation: "Бул операцияга уруксаттар жетишсиз",
    not_filled: "Толтурулган эмес",
    nothing_found: "Эч нерсе табылган жок",
    old_password: "Эски жашырынсөз",
    on_page: "Баракта",
    page_not_found: "Барак табылган жок",
    password: "Жашырынсөз",
    password_changed: "Жашырынсөз өзгөртүлдү",
    password_confirm: "Жашырынсөз тастыктоо",
    password_reset_link_sent: "Эгер бул логин менен аккаунт бар болсо, анын почтасына жашырынсөздү калыбына келтирүү шилтемеси жөнөтүлдү",
    password_reset_failed: "Сырсөздү баштапкы абалга келтирүү аракети ийгиликсиз болду",
    password_reset_requested: "Сырсөздү баштапкы абалга келтирүүнү сурады",
    password_reset_succeeded: "Сырсөздү ийгиликтүү баштапкы абалга келтирди",
    passwords_do_not_match: "Жашырынсөздөр дал келбейт",
    patient_search: "Бейтаптарды издөө",
    patient_tags_updated: "Бейтаптын белгилерин жаңыртты",
    payment_expires_at: "Төлөмдүн мөөнөтү аяктоодо",
    phone: "Телефон",
    photo: "Фото",
    price: "Баасы",
    print_noun: "Басып чыгаруу",
    professional: "Кесипкөй",
    profile: "Профиль",
    program: "Программа",
    refresh: "Жаңылоо",
    registration: "Каттоо",
    requirements: "Талаптар",
    reset: "Өзгөртүү",
    reset_password: "Жашырынсөздү өзгөртүү",
    reset_password_email_note: "Колдонуучуга жаңы сырсөз коюу үчүн шилтеме электрондук почтасына жөнөтүлөт",
    reset_success: "Өзгөртүү үчүн издин E-mail дарегиңизге баштапкы абалга келтирилген электрондук кат жөнөтүлдү",
    role: "Роль",
    russian: "Орус",
    save: "Сактоо",
    search: "Издөө",
    select: "Тандоо",
    send_reset_link: "Шилтемени жөнөтүү",
    sent: "Жөнөтүлдү",
    session_revoked: "Сессияны жокко чыгарды",
    sessions_revoked: "Башка бардык сессияларды жокко чыгарды",
    settings: "Орнотуулар",
    show: "Көрсөтүү",
    show_full: "Толоугу менен көрсөтүү",
    signin: "Кирүү",
    slogan: "Заманбап стоматологияны башкаруу үчүн булутка негизделген чечим",
    sorting: "Сорттоо",
    staff_rights_updated: "Кызматкердин укуктары жаңыртылды",
    staff_role_updated: "Кызматкердин ролу жаңыртылды",
    start: "Баштоо",
    start_noun: "Башталыш",
    status: "Статус",
    subscription_sum: "Жазылуу үчүн сумма",
    success_message: "Операция ийгиликтүү өттү",
    sum: "Сумма",
    system: "Системалык",
    table_search: "Таблица боюнча издөө",
    tech_specialist: "Техникалык адис",
    text: "Текст",
    there_are_unsaved_changes: "Сакталбаган өзгөртүүлөр бар",
    this_module_is_not_in_tariff: "Бул модул Free планына киргизилген эмес; Сизге Standard же Premium туташтыруу керек, ошондо сиз көп сандаган Dentist Plus программасынын мүмкүнчүлүктөрүнө ээ боло аласыз.",
    title: "Аталышы",
    to_top: "Жогору",
    today: "Бүгүн",
    total: "Бардыгы",
    translation: "Котормо",
    unknown: "Белгисиз",
    upload: "Жүктөө",
    web: "Web",
    who_has_access: "Кимге жеткиликтүү",
    wrong_file_format: "Файл форматы жараксыз",
    yes: "Ооба"
}
